// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"f3cf4297","226":"0326d0a9","246":"d64ca142","247":"c0fbee13","300":"2480ad4a"}[chunkId] + ".chunk.css";
};